"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RTBWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _actions = _interopRequireDefault(require("@site/pattern-library-core/actions"));
var _text = _interopRequireDefault(require("@ux/text"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c15c0st0"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-h1doz68e"
});
const RTBWrapper = exports.RTBWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RTBWrapper",
  class: "pl-r13sir0s"
});
const CtaWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CtaWrapper",
  class: "pl-cso6jl7"
});

/**
 * RTBTile Component.
 *
 * @param {Object} props React props
 * @returns {React.ReactElement} RTBTile Component
 * @public
 */

function RTBTile({
  tagLabel,
  heading,
  rtbList = [],
  ctas
}) {
  const IconType = /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: 'link-arrow'
  });
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, null, tagLabel && /*#__PURE__*/_react.default.createElement(_tag.default, {
    className: "tag",
    text: tagLabel,
    design: 'natural',
    size: "sm"
  }), /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: heading,
    headlineSize: "h3",
    textAlign: "start",
    fontType: "text"
  })), /*#__PURE__*/_react.default.createElement(RTBWrapper, null, rtbList.map((item, index) => /*#__PURE__*/_react.default.createElement("a", {
    key: index,
    href: item?.url,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "rtb-content"
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    text: item?.title,
    size: 0,
    className: "gdSherpa"
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    text: item?.description,
    size: -1
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon"
  }, IconType))))), /*#__PURE__*/_react.default.createElement(CtaWrapper, null, ctas && /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: ctas
  })));
}
var _default = exports.default = RTBTile;
RTBTile.propTypes = {
  tagLabel: _propTypes.default.string,
  heading: _propTypes.default.string,
  rtbList: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    description: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  ctas: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    href: _propTypes.default.string,
    design: _propTypes.default.string,
    size: _propTypes.default.string,
    templateName: _propTypes.default.string,
    width: _propTypes.default.string
  }))
};